<template>
    <table
        class="table"
        :class="{'table--stick-to-modal-sides' : stickToSides}"
    >
        <thead>
            <tr class="table__header-row">
                <th class="table__header-cell">
                    {{ $t('businessOrders.labels.sku') }}
                </th>
                <th class="table__header-cell">
                    {{ $t('businessOrders.labels.description') }}
                </th>
                <th v-if="anyItemHasLotData && businessOrder.isLotTrackedOrder"
                    class="table__header-cell"
                >
                    {{ $t('businessOrders.labels.lotnumber') }}
                </th>
                <th v-if="anyItemHasLotData && businessOrder.isLotTrackedOrder"
                    class="table__header-cell"
                >
                    {{ $t('businessOrders.labels.expiration') }}
                </th>
                <th class="table__header-cell">
                    {{ $t('businessOrders.labels.quantity') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in packageItems"
                :key="`${skuPrefix}_${item.sku}`"
                class="table__body-row"
            >
                <td class="table__body-cell">
                    {{ item.sku | valueOrDash }}
                </td>
                <td class="table__body-cell">
                    {{ item.description | valueOrDash }}
                </td>
                <td v-if="anyItemHasLotData && businessOrder.isLotTrackedOrder && item.isLotTrackedItemExpired"
                    class="table__body-cell text-error"
                >
                    {{ item.lotNumber | valueOrDash }}
                </td>
                <td v-else-if="anyItemHasLotData && isLotTrackedOrder"
                    class="table__body-cell"
                >
                    {{ item.lotNumber | valueOrDash }}
                </td>
                <td v-if="anyItemHasLotData && businessOrder.isLotTrackedOrder && item.isLotTrackedItemExpired"
                    class="table__body-cell text-error"
                >
                    {{ item.expirationDate | date('short') | valueOrDash }}
                </td>
                <td v-else-if="anyItemHasLotData && isLotTrackedOrder"
                    class="table__body-cell"
                >
                    {{ item.expirationDate | date('short') | valueOrDash }}
                </td>
                <td class="table__body-cell">
                    {{ item.quantity | valueOrDash }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        packageItems: {
            type: Array,
            default: () => [],
        },
        stickToSides: {
            type: Boolean,
            default: false,
        },
        skuPrefix: {
            type: String,
            default: '',
        },
        businessOrder: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        anyItemHasLotData() {
            const hasItemLotData = this.packageItems.some(item => item.lotNumber !== null && item.lotNumber !== '' && item.lotNumber !== undefined);
            return hasItemLotData;
        },
    },
};
</script>
